import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import BgImg from "../../images/locationgcc/hire-dubai/ideal_choice.webp";
import HtmlParser from "react-html-parser";

const idea = [
  {
    title: `Top <span>5%</span>`,
    subtit: "Proven Experience",
    txt: "Benefit from our team's rich experience, predominantly comprising mid and senior-level developers, ensuring tailored and effective solutions.",
  },
  {
    title: "95 <span>%</span>",
    subtit: "Top-Ranked App Developers with a 95% Approval Rating",
    txt: "Hire top-ranked app developers for quality results, with an impressive 95% approval rating from satisfied clients.",
  },
  {
    title: "9/<span>10</span>",
    subtit: "Achieving 9/10 in Client Satisfaction",
    txt: "Excelling with a 9/10 client satisfaction score, showcasing our commitment to delivering outstanding service and results.",
  },
];

function Idealchoice() {
  return (
    <div
      className="ideal_choice p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why We're the Ideal Choice to Hire App Developers and Make a
              Difference
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="ideal_dubai_box">
              {idea.map((item, index) => (
                <div className="ideal_box_item" key={index}>
                  <h2>{HtmlParser(item.title)}</h2>
                  <strong>{item.subtit}</strong>
                  <p>{item.txt}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Idealchoice;
